import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import coupon from "../../assets/img/coupon.png";
import back from "../../assets/img/icons/back.svg";
import textlogo from "../../assets/img/textlogo.svg";
import tick from "../../assets/img/icons/tick.svg";
import incorrect from "../../assets/img/icons/incorrect.svg";
import Payment from "./plan/payment";
import SuperlikePayment from "./plan/superlikepayment";
import BoostPayment from "./plan/boostpayment";
import axios from "axios";
import { Trans } from "react-i18next";
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Coupon extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleApplyCoupon = this.handleApplyCoupon.bind(this);
    this.handleclearcoupon = this.handleclearcoupon.bind(this);
    this.handlekeydowncoupon = this.handlekeydowncoupon.bind(this);

    this.state = {
      api_url: localStorage.getItem("api_url"),
      couponCode: "",
      inputClass: "",
      buttonText: "Apply",
      imageName: "",
      errorMessage: "",
      price: JSON.parse(localStorage.getItem("original_price")),
      original_price: JSON.parse(localStorage.getItem("original_price")),
      total_price: JSON.parse(localStorage.getItem("original_price")),
      selected_premium: JSON.parse(localStorage.getItem("selected_premium")),
      currency: JSON.parse(localStorage.getItem("currency")),
      premium_price: "",
      discount_price: 0,
      langKey: "en",
    };
  }

  componentDidMount() {
    if (
      this.props.i18n.language === "ar" ||
      this.props.i18n.language === "he"
    ) {
      document.body.dir = "rtl";
      document.body.classList.add("rtl");
      document.body.classList.remove("ltr");
    } else {
      document.body.dir = "ltr";
      document.body.classList.remove("rtl");
      document.body.classList.add("ltr");
    }
  }

  handleInputChange(event) {
    console.log("sdfdsfdsffffffffffffff");
    let buttonClassName, buttonText;

    if (event.target.value !== "") {
      buttonClassName = "coupondefault";
      buttonText = "Apply";
    } else {
      buttonClassName = "coupondisable";
      buttonText = "Apply";

      this.handleclearcoupon();
    }
    this.setState({
      couponCode: event.target.value,
      buttonClassName: buttonClassName,
      buttonText: buttonText,
      imageName: "",
    });
  }

  handlekeydowncoupon =(event)=>{
    if (event.key === 'Backspace') {
     this.handleclearcoupon()
    }
  }

  handleclearcoupon = () => {
    this.setState({
      discount_id: "",
      discount_price: 0.0,
      total_price: this.state.original_price,
      premium_price: this.state.original_pric,
      buttonText: "Apply",
      imageName: "",
      inputClass: "",
      buttonClassName: "coupondisable",
    });

    localStorage.removeItem("discount_id");
    localStorage.removeItem("original_price");
    localStorage.removeItem("discount_price");
    localStorage.removeItem("premium_price");
  };

  handleApplyCoupon = () => {
    if (this.state.couponCode !== "") {
      var discount = new FormData();
      discount.set(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      discount.set("price", this.state.price);
      discount.set("currency_code", this.state.currency);
      discount.set("couponCode", this.state.couponCode);
      discount.set("language", this.state.langKey);
      axios({
        method: "post",
        url: this.state.api_url + "applydiscountweb",
        data: discount,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          if (res.data.status === "true") {
            this.setState({
              discount_id: res.data.discount_id,
              original_price: res.data.original_price,
              discount_price: res.data.discount_price,
              total_price: res.data.total_price,
              premium_price: res.data.total_price,
              buttonText: "Applied",
              imageName: "tick",
              inputClass: "successinput",
              buttonClassName: "couponsuccess",
              inputClass: "successinput",
            });

            localStorage.setItem(
              "discount_id",
              JSON.stringify(this.state.discount_id)
            );
            localStorage.setItem(
              "original_price",
              JSON.stringify(this.state.original_price)
            );
            localStorage.setItem(
              "discount_price",
              JSON.stringify(this.state.discount_price)
            );
            localStorage.setItem(
              "premium_price",
              JSON.stringify(this.state.premium_price)
            );
          } else {
            this.setState({
              successMessage: res.data.message,
              suc_cls: "successMsg floatingAlerts1",
              buttonText: "Incorrect Code",
              imageName: "incorrect",
              inputClass: "errorinput",
              buttonClassName: "coupondanger",
              inputClass: "errorinput",
            });
            setTimeout(() => {
              this.setState({
                suc_cls: "successMsghide",
              });
            }, 3000);
          }
        })
        .catch((error) => {
          console.error("Error making API call:", error);
        });
    } else {
      this.setState({
        successMessage: "Kindly apply the coupon code.",
        suc_cls: "successMsg floatingAlerts1",
      });
      setTimeout(() => {
        this.setState({
          suc_cls: "successMsghide",
        });
      }, 3000);
    }
  };

  handlePaymentOpenModal = () => {
    const { type } = this.props.match.params;
    if (type === "premium") {
      this.setState({ paymentmodal: true });
    } else if (type === "superlike") {
      this.setState({ superlikepaymentmodal: true });
    } else if (type === "boost") {
      this.setState({ boostpaymentmodal: true });
    }
  };

  handlePaymentCloseModal = () => {
    this.setState({ paymentmodal: false });
  };

  handleSuperlikePaymentCloseModal = () => {
    this.setState({ superlikepaymentmodal: false });
  };

  handleBoostPaymentCloseModal = () => {
    this.setState({ boostpaymentmodal: false });
  };
  render() {
    const { inputClass, buttonText, imageName, buttonClassName } = this.state;
    const { t } = this.props;

    return (
      <>
        <div className="layout">
          <Container>
            <div className="welcome_header">
              <div className="welcomeheader_left">
                <Link to="/profile">
                  <img src={back} alt="img" />
                </Link>
                <Link to="/find">
                  <img src={textlogo} alt="img" className="couponimage_logo" />
                </Link>
              </div>
            </div>
          </Container>
          <div className="couponboxdiv">
            <Container>
              <Row className="aligned_center">
                <div className="whole_information">
                  {this.state.successMessage && (
                    <div className={this.state.suc_cls}>
                      {this.state.successMessage}
                    </div>
                  )}
                </div>
                <Col md={6} sm={6}>
                  <div className="coupon-image">
                    <img src={coupon} alt="img" />
                  </div>
                </Col>
                <Col md={6} sm={6}>
                  <div className="coupon_div">
                    <div className="">
                      <div className="coupon_title">
                        <h4>
                          <Trans i18nKey="Enter Coupon code">
                            Enter Coupon code
                          </Trans>
                        </h4>
                      </div>
                      <div className="coupon_form">
                        <Form className="">
                          <Form.Group
                            controlId="formPlaintextEmail"
                            className="coupon_form_div"
                          >
                            <Form.Label>
                              <Trans i18nKey="Do you have coupon code, Please apply?">
                                Do you have coupon code, Please apply?
                              </Trans>
                            </Form.Label>
                            <div>
                              <Form.Control
                                type="text"
                                placeholder={t("Apply code")}
                                value={this.state.couponCode}
                                onChange={(event) =>
                                  this.handleInputChange(event)
                                }
                                className={`${inputClass}`}
                                onKeyDown={this.handlekeydowncoupon}
                              />
                            </div>
                          </Form.Group>
                        </Form>
                        <div>
                          <Button
                            className={`coupondisable ${buttonClassName}`}
                            onClick={() => this.handleApplyCoupon()}
                          >
                            {imageName && (
                              <img
                                src={require(`../../assets/img/icons/${imageName}.svg`)}
                                alt="img"
                              />
                            )}
                            {buttonText}
                          </Button>
                        </div>
                      </div>
                      <div className="coupon_details">
                        <div className="coupondetails_div">
                          <div>
                            <h4>
                              <Trans i18nKey="Original price">
                                Original price
                              </Trans>
                            </h4>
                          </div>
                          <div>
                            <h3>
                              {this.state.currency}
                              {this.state.original_price}
                            </h3>
                          </div>
                        </div>
                        <div className="coupondetails_div">
                          <div>
                            <h4>
                              <Trans i18nKey="Discount price">
                                Discount price
                              </Trans>
                            </h4>
                          </div>
                          <div>
                            <h3>
                              -{this.state.currency}
                              {this.state.discount_price}
                            </h3>
                          </div>
                        </div>
                        <div className="coupondetails_lastdiv">
                          <div>
                            <h4>
                              <Trans i18nKey="Total amount">Total amount</Trans>
                            </h4>
                          </div>
                          <div>
                            <h3>
                              {this.state.currency}
                              {this.state.total_price}
                            </h3>
                          </div>
                        </div>
                        <div>
                          <Button
                            onClick={this.handlePaymentOpenModal}
                            className="button_primary"
                          >
                            <Trans i18nKey="Pay">Pay</Trans>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Payment
          showModal={this.state.paymentmodal}
          handleClose={this.handlePaymentCloseModal}
        />

        <SuperlikePayment
          showModal={this.state.superlikepaymentmodal}
          handleClose={this.handleSuperlikePaymentCloseModal}
        />
        <BoostPayment
          showModal={this.state.boostpaymentmodal}
          handleClose={this.handleBoostPaymentCloseModal}
        />
      </>
    );
  }
}

export default withTranslation("translations")(Coupon);
